import { Component, Input, EventEmitter, Output, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JoinSessionVM } from '../../models/JoinSessionVM';
import { FormBuilder } from '@angular/forms';
import { CommsService } from '../../../services/comms.service';
import { JoinSessionResponseVM } from '../../models/JoinSessionResponseVM';
import { SessionType } from '../../models/SessionType';
import { SessionStatus } from '../../models/SessionStatus';

@Component({
  selector: 'step-4-speed',
  templateUrl: './step-4-speed.component.html'
})
export class Step4SpeedComponent implements AfterViewInit {

  @Output() OnChanged: EventEmitter<number> = new EventEmitter();

  ngAfterViewInit(): void {
  }

  setDeviceSetupStage3() {
    this.OnChanged.emit(3);
  }

  setDeviceSetupStage5() {
    this.OnChanged.emit(5);
  }

}
